import { render } from "./Notificacoes.vue?vue&type=template&id=1e560540&scoped=true&ts=true"
import script from "./Notificacoes.vue?vue&type=script&lang=ts"
export * from "./Notificacoes.vue?vue&type=script&lang=ts"

import "./Notificacoes.vue?vue&type=style&index=0&id=1e560540&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e560540"]])

export default __exports__